import React from 'react';
import MyMap from '../components/MyMap';
import './home.css';
import '../App.css';
import BfwLogo from '../assets/turm.jpg';

function Home() {
  return (
    <div className="home-container">
      
      <div className="home-header">
        <h1>WALDÖKODATEN</h1>
      </div>

      <div className="home-map">
        <MyMap />
      </div>

      {/* Section bekommt aria-label für Screenreader */}
      <section 
        className="waldoekodaten-intro"
        aria-labelledby="waldoeko-heading"
      >
        <h2 id="waldoeko-heading">Das Datenportal „Waldökodaten“ des BFW</h2>

        <p>
          Das Bundesforschungszentrum für Wald (BFW) stellt über das Portal „Waldökodaten“ 
          täglich aktualisierte, ökologisch relevante Rohdaten kostenlos zur Verfügung. 
          Diese stammen aus Forschungs- und Monitoringaktivitäten des BFW oder wurden von 
          der Stadt Wien bereitgestellt.
        </p>

        <div className="text-image-block">
          <div className="text-column">
            <h3>Datenbereiche</h3>
            <ul>
              <li>Wetterdaten von waldnahen Freilandstationen</li>
              <li>Bodenfeuchte und Bodentemperatur im Bestand</li>
              <li>Änderung des Stammumfangs</li>
            </ul>

            <h3>Darstellung und Nutzung</h3>
            <ul>
              <li>Die Daten sind für die letzten 30 Tage verfügbar, die Daten der Stammumfänge dagegen bis zu einem Jahr.</li>
              <li>Diagramme können angezeigt und heruntergeladen werden.</li>
              <li>Zahlenwerte sind als CSV-Datei oder tabellarisch als PDF-Datei downloadbar.</li>
              <li>Details zur Nutzung der Daten sind im Impressum im Abschnitt „Copyright“ zu finden.</li>
            </ul>
          </div>

          <div className="image-column">
            {/* ALT-TEXT verbessert für Screenreader */}
            <img 
              src={BfwLogo} 
              alt="Turm des BFW – dekoratives Foto" 
              className="llogo" 
            />
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
